import { Action, combineReducers } from '@ngrx/store';
import { objDiff } from '../utility';

import {
  _CLEAR,
  CLEAR_BIN,
  GET_BINS,
  UPDATE_BIN,
  SET_BINS_VIEW
} from '../actions';

const initialBinsViewState = {
  loading: <boolean>false
};

export function binListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CLEAR_BIN:
      return state.map(bin => {
        const updatedBin = Object.assign({}, bin);

        if (bin.shipmentID === action.payload.shipment.id) {
          updatedBin.orderID = null;
          updatedBin.shipmentID = null;
        }

        return updatedBin;
      });
    case GET_BINS:
      return [ ...action.payload.bins ].sort(sortBins);
    case UPDATE_BIN:
      return state.map(bin => {
        return bin.id === action.payload.id
          ? objDiff(bin, action.payload.diffList)
          : bin;
      });
    default:
      return state;
  }
}

export function binsViewReducer(state = initialBinsViewState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return Object.assign({}, state, initialBinsViewState);
    case SET_BINS_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

function sortBins(bin1: any, bin2: any) {
  return +bin1.binNumber - +bin2.binNumber;
}

export const binsReducers = combineReducers({
  binList   : binListReducer,
  binsView  : binsViewReducer
});



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/ngrx/reducers/bins.ts